import React, { useContext } from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { Avatar } from 'browser/components/atomic-elements/atoms/avatar/avatar'
import { HelpBlock } from 'browser/components/atomic-elements/atoms/help-block/help-block'
import { Label } from 'browser/components/atomic-elements/atoms/label/label'

import { InternalViewContext } from 'browser/contexts/internal-view/internal-view-context'
import { Owner } from 'shared-libs/generated/server-types/entity'
import { renderAuthorHeader, renderEventTimestamp } from '../util'
import { Position, Tooltip } from '@blueprintjs/core'

interface INotificationLogItemProps extends IBaseProps {
  event: any
  owner: Owner
  index: number
  isFirst: boolean
  isLast: boolean
  workflowEntity: any
}

export const NotificationLogItem: React.FC<INotificationLogItemProps> = (props) => {
  const { className, event, owner, isFirst, workflowEntity } = props
  const { createdBy, creationDate, processedDate } = event
  const { showInternals } = useContext(InternalViewContext)

  const plan = _.get(workflowEntity, 'core_storyboard_execution.storyboardPlan.core_storyboard_plan')

  if (_.isEmpty(plan)) {
    return null
  }

  let message = null
  let type = 'Notification'
  if (_.get(event, 'details.sms.phone_number')) {
    message = event.details.sms.message
    type = 'SMS notification'
  } else if (_.get(event, 'details.push.receivers[0]')) {
    message = event.details.push.message
    type = 'Push notification'
  } else if (_.get(event, 'details.email.to[0]')) {
    message = event.details.email.text
    type = 'Email'
  } else {
    return null
  }

  const tooltip = (
    <div className="c-notificationTooltip">
      <div className="mb1">
        <b>{type} sent</b>
      </div>
      <i>"{message}"</i>
    </div>
  )

  return (
    <div
      className={classNames('c-timelineEvent', className)}
      key={event.uniqueId}
    >
      <div
        className={classNames('c-timelineEvent-line', className, {
          'c-timelineEvent-line--topCutOff': isFirst,
        })}
      />
      <div className='c-timelineEvent-dot' />
      <div className='c-timelineEvent-contentContainer'>
        { createdBy && (
          <div className='c-timelineEvent-header'>
          <div className='c-timelineEvent-author'>
            <Avatar
              className='c-timelineEvent-avatar'
              name={createdBy.displayName}
              size='xs'
            />
            <Label className='c-timelineEvent-authorName'>
              {renderAuthorHeader(createdBy, owner?.firm)}
            </Label>
          </div>
          <HelpBlock className='c-timelineEvent-timestamp'>
            {renderEventTimestamp(creationDate, processedDate, showInternals)}
          </HelpBlock>
          </div>
        ) }
        <div className='c-timelineEvent-body'>
          <Tooltip
            content={tooltip}
            position={Position.TOP}
            fill={false}
          >
            <div>{type} sent: <b>{event.details.name}</b></div>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
